import React from "react";
import moment from "moment";
import {
  Alerta,
  Box,
  TipoAlerta,
  CampoTexto,
  Botao,
  TamanhoBotao,
  TipoBotao,
  Col,
  CampoEstatico,
} from "@intechprev/componentes-web";
import {
  WebRecadDadosConclusaoEntidade,
  WebRecadParticipanteDadosEntidade,
  DependenteEntidade,
  EstadoCivilEntidade,
  UFEntidade,
  PaisEntidade,
  PlanoVinculadoEntidade,
  WebRecadPublicoAlvoEntidade,
} from "../../entidades";
import { PlanoService, RecadastramentoService } from "../../services";
import { OpcoesBanco } from "./OpcoesBanco";
import { NumFuncionalidade } from "../MasterPage";
import Avaliacao from "../../components/Avaliacao";
import { DMN_ORIGEM_SISTEMA } from "../../domains";

interface Props {
  DadosOriginais: WebRecadParticipanteDadosEntidade;
  RecadDados: WebRecadDadosConclusaoEntidade;
  ListaDependente: Array<DependenteEntidade>;
  Voltar: () => void;
  Reiniciar: () => void;
  NumeroPassoAtual: number;
  Recad: WebRecadPublicoAlvoEntidade;
}

interface State {
  EstadoCivil: EstadoCivilEntidade;
  UF: UFEntidade;
  Pais: PaisEntidade;
  Banco: any;
  StatusRecad: string;
  Token: string;
  BotaoTokenTitulo: string;
  EmailToken: string;
  CelularToken: string;
  OpcaoToken: string;
  TokenGerado: string;
  checked: boolean;
  CorCheckbox: string;

  modalAvaliacao: boolean;
  Plano: PlanoVinculadoEntidade;
}

export class Passo10 extends React.Component<Props, State> {
  private alerta = React.createRef<Alerta>();

  constructor(props: Props) {
    super(props);

    this.state = {
      EstadoCivil: new EstadoCivilEntidade(),
      UF: new UFEntidade(),
      Pais: new PaisEntidade(),
      Banco: null,
      StatusRecad: "",
      Token: "",
      BotaoTokenTitulo: "Enviar Token",
      EmailToken: "",
      CelularToken: "",
      OpcaoToken: "",
      TokenGerado: null,
      CorCheckbox: "danger",
      checked: false,
      modalAvaliacao: false,
      Plano: new PlanoVinculadoEntidade()
    };
  }

  componentDidMount = async () => {
    try {
      // this.page.current.loading(false);
      // const NumeroPassoAlternativo = this.Pensionista() ? "4" : "5";
      const EstadoCivil = this.props.RecadDados.Participante.CD_ESTADO_CIVIL
        ? await RecadastramentoService.BuscarEstadoCivil(this.props.RecadDados.Participante.CD_ESTADO_CIVIL)
        : null;
      const UF = this.props.RecadDados.Participante.UF_ENTID
        ? await RecadastramentoService.BuscarUF(this.props.RecadDados.Participante.UF_ENTID)
        : null;
      const Pais = this.props.RecadDados.Participante.CD_PAIS
        ? await RecadastramentoService.BuscarPais(this.props.RecadDados.Participante.CD_PAIS)
        : null;
      const Banco = this.props.RecadDados.Participante.NUM_BANCO
        ? OpcoesBanco.filter((b) => b.Value === this.props.RecadDados.Participante.NUM_BANCO)[0].Name
        : null;

      const planos = await PlanoService.Buscar();

      this.setState({
        EstadoCivil,
        UF,
        Pais,
        Banco,
        CelularToken: this.props.DadosOriginais.FONE_CELULAR || "",
        EmailToken: this.props.DadosOriginais.EMAIL_AUX || "",
        Plano: planos[0]
      });
    } catch (e) {
      const err: any = e;
      await this.alerta.current.adicionarErro(err.response ? err.response.data : err);
    }
  };

  enviarToken = async () => {
    try {
      await this.alerta.current.limparErros();

      const metodoEnvio = this.state.OpcaoToken === "C" ? "sms" : this.state.OpcaoToken === "E" ? "email" : "";
      const alvoEnvio =
        this.state.OpcaoToken === "C"
          ? this.state.CelularToken.replace(/\(|\)|-/gm, "")
          : this.state.OpcaoToken === "E"
            ? this.state.EmailToken
            : "";

      const TokenGerado = await RecadastramentoService.GerarToken(metodoEnvio, alvoEnvio);

      this.setState({
        TokenGerado,
        BotaoTokenTitulo: "caso não receba o código pelo meio selecionado, clique aqui para reenviar",
      });

      window.alert("Código enviado! Por favor aguarde.");
    } catch (e) {
      const err: any = e;
      await this.alerta.current.adicionarErro(err.response ? err.response.data.text : err);
    }
  };

  isEmptyString = (string: string) => {
    return string === "" || string === undefined || string === null || string.length === 0;
  };

  Voltar = () => {
    this.props.Voltar();
  };

  Concluir = async () => {
    try {
      await this.alerta.current.limparErros();

      if (!this.state.checked) {
        return await this.alerta.current.adicionarErro(
          "É necessario manifestar ciência e plena concordância com as informações aqui registradas para prosseguir com o recadastramento."
        );
      }

      if (this.state.Token === "") {
        return await this.alerta.current.adicionarErro("É necessario realizar o envio do código para concluir o Recadastramento.");
      }

      const dadosFinals = this.props.RecadDados;
      dadosFinals.OID_RECAD_PUBLICO_ALVO_Original = this.props.Recad.OID_RECAD_PUBLICO_ALVO;
      dadosFinals.Origem = DMN_ORIGEM_SISTEMA.PORTAL;
      dadosFinals.Token = this.state.TokenGerado;
      dadosFinals.TokenDigitado = this.state.Token;

      const StatusRecad = await RecadastramentoService.Concluir(dadosFinals);

      this.setState({
        modalAvaliacao: true,
        StatusRecad
      });
    } catch (e) {
      const err: any = e;
      await this.alerta.current.adicionarErro(err.response ? err.response.data.text : err);
    }
  };

  handleEnviarAvaliacao = async () => {
    this.setState({
      modalAvaliacao: false,
    }, () => this.props.Reiniciar());
  };

  renderCampos = () => {
    const Alteracoes = [];

    if (this.props.RecadDados.Participante.NOME_ENTID) {
      Alteracoes.push(<CampoEstatico key={1} valor={this.props.RecadDados.Participante.NOME_ENTID} titulo={"Nome"} tamanhoTitulo={"4"} />);
    }

    if (this.props.RecadDados.Participante.DT_EMIS_IDENT) {
      Alteracoes.push(
        <CampoEstatico key={2} valor={this.props.RecadDados.Participante.DT_EMIS_IDENT} titulo={"Data de Emissão"} tamanhoTitulo={"4"} />
      );
    }

    if (this.props.RecadDados.Participante.ORG_EMIS_IDENT) {
      Alteracoes.push(
        <CampoEstatico key={3} valor={this.props.RecadDados.Participante.ORG_EMIS_IDENT} titulo={"Órgão Emissor"} tamanhoTitulo={"4"} />
      );
    }

    if (this.props.RecadDados.Participante.CD_ESTADO_CIVIL) {
      Alteracoes.push(<CampoEstatico key={4} valor={this.state.EstadoCivil.DS_ESTADO_CIVIL} titulo={"Estado Civil"} tamanhoTitulo={"4"} />);
    }

    if (this.props.RecadDados.Participante.NOME_CONJUGE) {
      Alteracoes.push(
        <CampoEstatico key={5} valor={this.props.RecadDados.Participante.NOME_CONJUGE} titulo={"Nome do Conjuge"} tamanhoTitulo={"4"} />
      );
    }

    if (this.props.RecadDados.Participante.CPF_CONJUGE) {
      Alteracoes.push(<CampoEstatico key={6} valor={this.props.RecadDados.Participante.CPF_CONJUGE} titulo={"CPF do Conjuge"} tamanhoTitulo={"4"} />);
    }

    if (this.props.RecadDados.Participante.CEP_ENTID) {
      Alteracoes.push(<CampoEstatico key={7} valor={this.props.RecadDados.Participante.CEP_ENTID} titulo={"CEP"} tamanhoTitulo={"4"} />);
    }

    if (this.props.RecadDados.Participante.END_ENTID) {
      Alteracoes.push(<CampoEstatico key={8} valor={this.props.RecadDados.Participante.END_ENTID} titulo={"Endereço"} tamanhoTitulo={"4"} />);
    }

    if (this.props.RecadDados.Participante.NR_END_ENTID) {
      Alteracoes.push(<CampoEstatico key={9} valor={this.props.RecadDados.Participante.NR_END_ENTID} titulo={"Número"} tamanhoTitulo={"4"} />);
    }

    if (this.props.RecadDados.Participante.COMP_END_ENTID) {
      Alteracoes.push(
        <CampoEstatico key={10} valor={this.props.RecadDados.Participante.COMP_END_ENTID} titulo={"Complemento"} tamanhoTitulo={"4"} />
      );
    }

    if (this.props.RecadDados.Participante.BAIRRO_ENTID) {
      Alteracoes.push(<CampoEstatico key={11} valor={this.props.RecadDados.Participante.BAIRRO_ENTID} titulo={"Bairro"} tamanhoTitulo={"4"} />);
    }

    if (this.props.RecadDados.Participante.CID_ENTID) {
      Alteracoes.push(<CampoEstatico key={12} valor={this.props.RecadDados.Participante.CID_ENTID} titulo={"Cidade"} tamanhoTitulo={"4"} />);
    }

    if (this.props.RecadDados.Participante.UF_ENTID) {
      Alteracoes.push(<CampoEstatico key={13} valor={this.state.UF.DS_UNID_FED} titulo={"Estado"} tamanhoTitulo={"4"} />);
    }

    if (this.props.RecadDados.Participante.CD_PAIS) {
      Alteracoes.push(<CampoEstatico key={14} valor={this.state.Pais.DS_PAIS} titulo={"País"} tamanhoTitulo={"4"} />);
    }

    if (this.props.RecadDados.Participante.EMAIL_AUX) {
      Alteracoes.push(<CampoEstatico key={15} valor={this.props.RecadDados.Participante.EMAIL_AUX} titulo={"E-mail Pessoal"} tamanhoTitulo={"4"} />);
    }

    if (this.props.RecadDados.Participante.FONE_ENTID) {
      Alteracoes.push(
        <CampoEstatico key={16} valor={this.props.RecadDados.Participante.FONE_ENTID} titulo={"Telefone Residencial"} tamanhoTitulo={"4"} />
      );
    }

    if (this.props.RecadDados.Participante.FONE_CELULAR) {
      Alteracoes.push(
        <CampoEstatico key={17} valor={this.props.RecadDados.Participante.FONE_CELULAR} titulo={"Telefone Celular"} tamanhoTitulo={"4"} />
      );
    }

    if (this.props.RecadDados.Participante.NUM_BANCO) {
      Alteracoes.push(<CampoEstatico key={18} valor={this.state.Banco} titulo={"Número do Banco"} tamanhoTitulo={"4"} />);
    }

    if (this.props.RecadDados.Participante.NUM_AGENCIA) {
      Alteracoes.push(
        <CampoEstatico key={19} valor={this.props.RecadDados.Participante.NUM_AGENCIA} titulo={"Agência (sem o Dígito)"} tamanhoTitulo={"4"} />
      );
    }

    if (this.props.RecadDados.Participante.NUM_CONTA) {
      Alteracoes.push(
        <CampoEstatico key={20} valor={this.props.RecadDados.Participante.NUM_CONTA} titulo={"Conta Corrente (com o DV)"} tamanhoTitulo={"4"} />
      );
    }

    if (this.props.RecadDados.Participante.POLIT_EXP) {
      Alteracoes.push(
        <CampoEstatico key={21} valor={this.props.RecadDados.Participante.POLIT_EXP} titulo={"Pessoa Politicamente Exposta"} tamanhoTitulo={"4"} />
      );
    }

    return Alteracoes.length > 0 ? Alteracoes : null;
  };

  renderDependentesAlterados = () => {
    // confere se houve alteracoes
    if (this.props.ListaDependente.some((dep) => dep.hasOwnProperty("IND_OPERACAO"))) {
      // lista de deps sem os removidos
      const deps = this.props.ListaDependente.filter((dep) => dep.IND_OPERACAO !== "EXC");
      if (deps.length > 0) {
        const li = deps.map((dep: DependenteEntidade, index: number) => {
          const cor = index % 2 === 0 ? "table-active" : "";
          return (
            <tr className={cor} key={index}>
              <td>{dep.DS_GRAU_PARENTESCO}</td>
              <td>{dep.NOME_DEP}</td>
              <td>{moment(dep.DT_NASC_DEP, "DD/MM/YYYY").format("DD/MM/YYYY")}</td>
              <td>{dep.SEXO_DEP === "F" ? "FEMININO" : "MASCULINO"}</td>
              <td>{dep.CPF}</td>
            </tr>
          );
        });
        return (
          <Box titulo={"Beneficiários para Fins de Pensão"}>
            <table className={"table table-responsive table-bordered"}>
              <thead>
                <tr>
                  <th style={{ width: "150" }}>Grau de Parentesco</th>
                  <th style={{ width: "250" }}>Nome</th>
                  <th style={{ width: "150" }}>Data de Nascimento</th>
                  <th>Sexo</th>
                  <th>CPF</th>
                </tr>
              </thead>
              <tbody>{li}</tbody>
            </table>
          </Box>
        );
      }
      return <Alerta mensagem={"Sem beneficiários para fins de pensão."} tipo={TipoAlerta.danger} />;
    }
    return null;
  };

  renderAlteracoes = () => {
    const Alteracoes = [this.renderCampos(), this.renderDependentesAlterados()];

    const HouveAlteracao = Alteracoes.some((item) => item !== null);

    if (HouveAlteracao) {
      return Alteracoes;
    }
    return (
      <Alerta
        mensagem={"Nenhuma informação foi alterada nos passos anteriores. Contudo, você deve concluir seu recadastramento abaixo."}
        tipo={TipoAlerta.info}
      />
    );
  };

  render() {
    return (
      <>
        {this.state.modalAvaliacao && (
          <Avaliacao numFuncionalidade={NumFuncionalidade.RECADASTRAMENTO} cdPlano={this.state.Plano.CD_PLANO} onSend={this.handleEnviarAvaliacao} />
        )}
        <Box titulo={`Passo ${this.props.NumeroPassoAtual} - Resumo e Confirmação`}>
          <br />

          <span>{"As informações a seguir foram alteradas por você e serão efetivadas no seu cadastro na PREVIRB"}</span>

          <br />

          <br />

          <br />

          {this.renderAlteracoes()}

          <Box>
            <div className={`d-flex alert alert-${this.state.CorCheckbox}`}>
              <input
                type={"checkbox"}
                id={"manifestacao"}
                name={"manifestacao"}
                checked={this.state.checked}
                onChange={() => {
                  this.setState({
                    checked: !this.state.checked,
                    CorCheckbox: !this.state.checked ? "success" : "danger",
                  });
                }}
              />
              <label className={"m-2"} htmlFor={"manifestacao"}>
                {"Manifesto ciência e plena concordância com as informações aqui registradas, atestando a veracidade das mesmas."}
              </label>
            </div>

            {this.isEmptyString(this.state.StatusRecad) && <>
              <Alerta
                tipo={TipoAlerta.danger}
                mensagem={"Para concluir a sua solicitação de recadastramento, enviaremos um token de confirmação para o seu celular e/ou e-mail."}
              />

              <div className={"box d-flex flex-column p-3 w-75"}>
                <label className={"d-flex flex-column"}>
                  <div className={"d-flex align-items-center"}>
                    <input
                      name={"OpcaoToken"}
                      className={"m-2"}
                      value={"C"}
                      type={"radio"}
                      checked={this.state.OpcaoToken === "C"}
                      onChange={(e: any) => {
                        this.setState({
                          OpcaoToken: e.target.value,
                        });
                      }}
                    />
                    {"Enviar Token para celular"}
                  </div>
                  <CampoTexto contexto={this} nome={"CelularToken"} valor={this.state.CelularToken} mascara={"(99)99999-9999"} />
                </label>

                <label className={"d-flex flex-column"}>
                  <div className={"d-flex align-items-center"}>
                    <input
                      name={"OpcaoToken"}
                      className={"m-2"}
                      value={"E"}
                      type={"radio"}
                      checked={this.state.OpcaoToken === "E"}
                      onChange={(e: any) => {
                        this.setState({
                          OpcaoToken: e.target.value,
                        });
                      }}
                    />
                    {"Enviar Token para e-mail"}
                  </div>
                  <CampoTexto contexto={this} nome={"EmailToken"} valor={this.state.EmailToken} />
                </label>

                <Botao
                  titulo={this.state.BotaoTokenTitulo}
                  className={"m-2"}
                  tamanho={TamanhoBotao.pequeno}
                  tipo={TipoBotao.primary}
                  onClick={this.enviarToken}
                  desativado={this.state.OpcaoToken === ""}
                  usaLoading
                />

                <div className={"col-md-12 col-form-label "}>
                  <b>
                    <label htmlFor={"Token"}>{"Digite o Token enviado"}</label>
                  </b>
                </div>
                <Col>
                  <CampoTexto contexto={this} nome={"Token"} valor={this.state.Token} />
                </Col>
              </div>

              <Alerta ref={this.alerta} tipo={TipoAlerta.danger} />

              <Botao
                onClick={this.Voltar}
                titulo={"Voltar"}
                tamanho={TamanhoBotao.grande}
                className={"m-2"}
                tipo={TipoBotao.light}
                icone={"angle-double-left"}
                iconeDireita
              />

              <Botao
                titulo={"Concluir Recadastramento"}
                tamanho={TamanhoBotao.grande}
                tipo={TipoBotao.primary}
                desativado={!this.state.checked}
                usaLoading
                onClick={this.Concluir}
              />
            </>}

            {!this.isEmptyString(this.state.StatusRecad) && <Alerta mensagem={this.state.StatusRecad} tipo={TipoAlerta.info} />}
          </Box>
        </Box>
      </>
    );
  }
}
